<p-dialog header="" [(visible)]="isFlag" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{ width: '60vw' }">
    <form [formGroup]="accountOpeningBalancetForm">
        <div class="header">
            <h5>
                Add Opening Balance
            </h5>
        </div>
        <div class="card">
            <div class="p-field p-formgrid p-grid">
                <div class="p-col-12 p-md-6">
                    <label>Opening Balance<span style="color: red">*</span></label>
                    <p-inputNumber [min]="0" mode="decimal" [minFractionDigits]="decimalPlaces" [maxFractionDigits]="decimalPlaces" formControlName="OpeningBalanceValue"></p-inputNumber>
                </div>
                <div class="p-col-12 p-md-6">
                    <label for="name">As Of Date <span style="color: red">*</span></label>
                    <p-calendar appendTo="body" [monthNavigator]="true" [yearNavigator]="true" placeholder="mm/dd/yyyy"
                    dateFormat="mm/dd/yy" yearRange="1900:2100" [(ngModel)]="startingDate" [ngModelOptions]="{standalone: true}"
                      formControlName="startingDate"
                         ></p-calendar>
                </div>
            </div>
        </div>
    </form>
    <p-footer >
        <button type="button" pButton label="Cancel"  (click)="CancelPopup()" class="p-button-secondary"></button>
        <button type="button" [disabled]="!accountOpeningBalancetForm.valid"  (click)="saveAccountOpeningBalancetForm(accountOpeningBalancetForm.value)" pButton class="p-button-success" label="Submit"></button>
    </p-footer>
</p-dialog>